module.exports = "hr{background-color:#06f}label{font-weight:bolder}"